var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row",attrs:{"id":"barcodePrint"}},_vm._l((_vm.items),function(n){return _c('div',{key:n,staticClass:"col-md-3",attrs:{"md":"4"}},[_c('barcode',{attrs:{"height":_vm.vHeight,"width":"1","value":_vm.printValue}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }